import ResourceBase from './../shared/resource-base';
import BrokerageProfile from './brokerage-profile-model';
import ModelSchemas from './../shared/model-schema';
import { deserialize, serialize, primitive } from 'serializr';
import _ from 'lodash';

export default class BrokerageProfileResource extends ResourceBase {
    constructor() {
        super(BrokerageProfile);

        this.schema = ModelSchemas.createBrokerageProfileSchema(BrokerageProfile, {
            createdBy: primitive(),
            createdOn: primitive(),
            updatedBy: primitive(),
            updatedOn: primitive(),
        });
    }

    getBrokerageProfileBySubscriberId(token, subscriberId) {
        return new Promise((resolve, reject) => {
            this.find(token, { filter: { where: { subscriberId: subscriberId } } })
                .then(profileJSON => {
                    const profileModel =
                        profileJSON.length > 0
                            ? deserialize(this.schema, _.first(profileJSON))
                            : new BrokerageProfile();

                    resolve(profileModel);
                })
                .catch(reject);
        });
    }

    saveBrokerageProfile(token, brokerageProfileModel, dirtyFields) {
        if (brokerageProfileModel.brokerageProfileId && brokerageProfileModel.brokerageProfileId.length >= 36) {
            return this.updateExistingBrokerageProfile(token, brokerageProfileModel, dirtyFields);
        } else {
            return this.createNewBrokerageProfile(token, brokerageProfileModel, dirtyFields);
        }
    }

    updateExistingBrokerageProfile(token, brokerageProfileModel, dirtyFields) {
        return this.patch(
            token,
            brokerageProfileModel.brokerageProfileId,
            _.pick(serialize(brokerageProfileModel), dirtyFields)
        );
    }

    createNewBrokerageProfile(token, brokerageProfileModel, dirtyFields) {
        return this.post(token, _.pick(serialize(brokerageProfileModel), dirtyFields));
    }
}



// WEBPACK FOOTER //
// ./src/agent-profile/brokerage-profile-resource.js